'use strict';

/* ========================================================
 * 		Requires
 ========================================================= */

// Polyfill - Most are in polyfill.js, but the ones here can't be tested for easily
require('svgxuse');

// Lib
var loadScript = require('./lib/loadScript.js');
var ComponentManager = require('./lib/ComponentManager.js');
var Forms = require('./lib/Forms.js');
var AutoLoadPages = require('./lib/AutoLoadPages.js');
var LiveIntersectionObserver = require('./lib/LiveIntersectionObserver.js');
var LiveImageLoadObserver = require('./lib/LiveImageLoadObserver.js');
var LiveStyleCodeBlocks = require('./lib/LiveStyleCodeBlocks.js');
var LdJsonTools = require('./lib/LdJsonTools.js');
window["LdJsonTools"] = LdJsonTools;

// Website Analytics (e.g. Google Analytics)
var WebsiteAnalytics = require('./lib/WebsiteAnalytics.ts');

// Site
var Menu = require('./site/Menu.js');

// Components
var Accordion = require('./components/Accordion.js');
var IntroSection = require('./components/IntroSection.js');
var BookletSection = require('./components/BookletSection.js');
var Video = require('./components/Video.js');
var GallerySection = require('./components/GallerySection.js');
var ScrollGallerySection = require('./components/ScrollGallerySection.js');
var JumpToNextSection = require('./components/JumpToNextSection.js');



/* ========================================================
 * 		Setup
 ========================================================= */
function setup() {
	WebsiteAnalytics.init();
	
	// Init various misc. components
	// TODO Modify the items in this block to use ComponentManager, and work for AJAX purposes (and any situation really).
	new Menu();
	Forms.init();
	var autoLoadPages = new AutoLoadPages({
		scrollableArea: window,
		resultsAreaSelector: '.articleList',
		resultsSelector: '.articleList__item',
		paginationSelector: '.pagination',
		nextSelector: '.btn--next:not(.disabled)',
		loadWhenDistanceFromBottom: 200
	});

	// Register Components
	var componentManager = ComponentManager.getInstance();
	componentManager.register(JumpToNextSection); // The .start() needs to be called to show. This is done via IntroSection.
	componentManager.register(IntroSection);
	componentManager.register(Video);
	componentManager.register(GallerySection);
	componentManager.register(ScrollGallerySection);
	componentManager.register(BookletSection);
	componentManager.register(Accordion, {
		selectors : {
			item : '> .accordion__item',
			body : '> .accordion__bodyWrap > .accordion__body',
			content : '> .accordion__bodyWrap > .accordion__body > .accordion__content',
			control : '> .accordion__heading'
		}
	});
	
	// Mark elements as they come into the viewport.
	/* TODO
	 * 		Consider changing these to have ComponentManager manage them.
	 * 		And can I some of the existing code store instances related to an element and dispose of
	 * 			references appropriately and automatically? One way would be to use a class which is notified of DOM changes
	 * 			And then loops through its contents to check if the document still contains the element: https://developer.mozilla.org/en-US/docs/Web/API/Node/contains
	 * 				That may be a little slow though; don't know.
	*/
	var viewportIntersection = new LiveIntersectionObserver();
	viewportIntersection.addStyleClass(IntroSection.COMPONENT_STYLE_CLASS);
	viewportIntersection.addStyleClass('callToAction');
	viewportIntersection.addStyleClass('ourWorkIntroSection');
	viewportIntersection.addStyleClass('entryAboutSectionText');
	viewportIntersection.addStyleClass('entryRecentArticles');
	viewportIntersection.addStyleClass('scrollGallerySection__contentSticky');
	viewportIntersection.addStyleClass('scrollGallerySection__media');
	viewportIntersection.addStyleClass('mediaGrid');
	viewportIntersection.addStyleClass('ourWorkNavigation');
	viewportIntersection.addStyleClass('gridSection__item--text');
	viewportIntersection.addStyleClass('gridSection__item--image');
	viewportIntersection.addStyleClass('mastheadImageSection');
	viewportIntersection.addStyleClass('listItem');
	viewportIntersection.addStyleClass('listItem');
	viewportIntersection.addStyleClass('listItem--featured');
	viewportIntersection.addStyleClass('listItem--featuredAlt');
	
	new LiveImageLoadObserver('js-markImgLoaded', 'image__visibleImage');
	new LiveStyleCodeBlocks();
	
} // EOF: setup()




/* ========================================================
 * 		Check if polyfills are needed, then call setup()
 ========================================================= */
function needsPolyfill() {
	// IntersectionObserver
	if ('IntersectionObserver' in window === false
			|| 'IntersectionObserverEntry' in window === false
			|| 'intersectionRatio' in window.IntersectionObserverEntry.prototype === false)
		return true;
    
	// Promises
	if (window.Promise === undefined)
		return true;
	
	// performance.now()
	if ('performance' in window === false || 'now' in window.performance === false)
		return true;
	
	// requestAnimationFrame
	if (window.requestAnimationFrame === undefined)
		return true;
	
	// classList
	var testElem = document.createElement('_');
	if ('classList' in testElem === false)
		return true;
	
	testElem.classList.add('c1', 'c2');
	if (! testElem.classList.contains('c2'))
		return true
	
	testElem.classList.toggle('c3', false);
	if (testElem.classList.contains("c3"))
		return true;
	
	// #Element.closest and #Element.matches
	var ElementProto = window.Element.prototype;
	if (typeof ElementProto.matches !== 'function' || typeof ElementProto.closest !== 'function')
		return true;
	
	// I am not testing for the following support because the above should catch them and they are harder to test on their own:
	// * dataset
	
	// Passed all checks, return false indicating polyfilling is not needed
	return false;
}
if (needsPolyfill()) {
	loadScript('/assets/theme/target/polyfills.js', setup);
} else {
	setup();
}

